<template>
  <div class="trainer-manager__content">
    <v-form :handle-submit="handleSubmitUpdatePassword">
      <v-text-field
        name="newPassword"
        @keyup.enter="handleSubmit"
        type="password"
        v-model="updatePassword.newPassword"
        v-validate="'required'" data-vv-value-path="input" data-vv-name="newPassword"
        data-vv-as="new password"
        :message-error="errors && errors.first ? errors.first('newPassword') : ''"
        :has-error="errors && errors.has ? errors.has('newPassword') : ''"
        :block="true">
        <template slot="label">
          New password: *
        </template>
      </v-text-field>

      <v-button @click="handleSubmitUpdatePassword" :block="true" :disabled="loadingUpdatePassword">
        {{ loadingUpdatePassword ? 'Loading...' : 'Save' }}
      </v-button>
    </v-form>
  </div>
</template>

<script>
import VForm from '@/components/Forms/VForm'
import VTextField from '@/components/Forms/VTextField'
import VButton from '@/components/Forms/VButton'
import { mapActions } from 'vuex'

export default {
  name: 'UpdateTrainerPassword',
  props: ['userId'],
  data: () => ({
    updatePassword: {
      newPassword: '',
      userId: null
    },
    loadingUpdatePassword: false
  }),
  methods: {
    async handleSubmitUpdatePassword () {
      const isValid = await this.$validator.validateAll()

      if (isValid) {
        this.loadingUpdatePassword = true

        const isUpdated = await this.updateTrainerPassword(this.updatePassword)

        this.updatePassword.newPassword = ''
        this.$validator.reset()

        this.loadingUpdatePassword = false

        if (isUpdated) {
          this.$swal(
            'Updated!',
            'The password of trainer has been updated.',
            'success'
          )

          return true
        }

        this.$swal(
          'Error!',
          'Something is wrong.',
          'error'
        )

        return false
      }
    },
    ...mapActions({
      updateTrainerPassword: 'trainers/updateTrainerPassword'
    })
  },
  created () {
    this.updatePassword.userId = this.userId
  },
  watch: {
    userId () {
      this.updatePassword.userId = this.userId
    }
  },
  components: {
    VForm,
    VTextField,
    VButton
  }
}
</script>

<style lang="stylus" scoped>
  form
    label
      &:not(:last-of-type)
        margin-bottom 20px

    button
      margin 20px 0 0
</style>



// WEBPACK FOOTER //
// UpdatePassword.vue?276b5b60